import { render, staticRenderFns } from "./stdbillR.vue?vue&type=template&id=a9793f6a&scoped=true&"
import script from "./stdbillR.vue?vue&type=script&lang=js&"
export * from "./stdbillR.vue?vue&type=script&lang=js&"
import style0 from "./stdbillR.vue?vue&type=style&index=0&id=a9793f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9793f6a",
  null
  
)

export default component.exports